// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsBookingInfo_root__1FBWZ","bookingParticipantBreakdown":"DetailsBookingInfo_bookingParticipantBreakdown__2tsCy"};